module.exports = __webpack_public_path__ + "static/media/dijon-5.e9fe76bc.jpg";